import React, { useContext } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { SettingsContext } from '../../context/SettingsContext';
export default function AppearanceControl() {
  const { appearance, setAppearance } = useContext(SettingsContext);
  return <FormControl size="small" sx={{ minWidth: 100 }}><Select value={appearance || 'system'} onChange={e => setAppearance(e.target.value)} inputProps={{ 'aria-label': 'Appearance' }}>
    <MenuItem value="light">Light</MenuItem><MenuItem value="dark">Dark</MenuItem><MenuItem value="system">System</MenuItem>
  </Select></FormControl>;
}
